import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/workspaces/new")({
  beforeLoad: () => {
    throw redirect({ to: "/", replace: true });
  },
});
